import React, { useCallback } from 'react';
import classnames from 'classnames';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import ArrowLeft from '@wix/da-ds/pkg/Icons/ArrowLeft';
import { Url } from '@wix/da-url';
import s from './BackToStashButton.scss';
const BackToStreamButton = ({ className, folder })=>{
    const openStash = useCallback(()=>{
        if (folder && folder.folderId) {
            window.location.assign(Url.stashFolderLink(folder.folderId));
        }
    }, [
        folder
    ]);
    if (!folder || !folder.folderId) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(TextButton, {
        icon: ArrowLeft,
        variant: "main",
        size: "small",
        className: classnames(s['duperexit'], className),
        onClick: openStash,
        noHorizontalPaddings: false
    }, "Back to ", folder.name);
};
BackToStreamButton.displayName = 'BackToStreamButton';
export default BackToStreamButton;
